module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray-ecd4e49302f33f1ffe77c31bf43000bf.png";